<template>
  <div class="wrap_chat_veiw w-100 h-100 exclude_close_overlays">
    <div class="wrap_chat p-4 w-100 h-100 overflow-auto">
      <div v-if="chatList.length == 0" class="d-flex justify-content-center p-5 text-muted">
        {{ this.$t('목록이 없습니다.') }}
      </div>
      <div v-else class="chat-items">
        <transition-group name="list" tag="div">
          <div v-for="(chat, index) in chatList" class="list-item d-flex mb-4 chat-item" 
            :key="index" :class="{ 'justify-content-end': chat.mine, 'justify-content-start': !chat.mine }">
            <div class="d-flex position-relative" style="width: 88%;" :class="{ 'bg-light-warning': chat.mine, 'bg-light-dark': !chat.mine }">
              <div class="d-flex flex-grow-1 flex-column p-3 pt-2 rounded text-gray-900 fw-semibold mw-lg-400px text-start">
                <div class="d-flex align-items-center mb-1">
                  <span v-if="chat.header" v-text="chat.header" :class="`me-2 badge badge-sm badge-` + chat.headerVariant"></span>
                  <b class="fs-7" v-text="chat.regUserNm"></b>
                  <span class="flex-grow-1 text-right fs-8 text-muted ms-2" v-text="chat.regDt.f('datetime-local')"></span>

                  <span v-if="chat.updatable || chat.deletable" :id="`chatForm_${chat.messageId}`" style="margin-right: -6px; padding-left: 4px;">
                    <b-dropdown variant="link" toggle-class="text-decoration-none p-0" menu-class="min-w-auto px-1" no-caret>
                      <template #button-content>
                        <a class="btn btn-xs btn-icon btn-circle btn-icon-dark btn-active-secondary" :title="$t('기능')" @click="closeChatForm">
                          <i class="bi bi-three-dots-vertical fs-6"></i>
                        </a>
                      </template>
                      <b-dropdown-item :disabled="!chat.updatable" @click="showChatForm(chat)">{{ $t('수정') }}</b-dropdown-item>
                      <b-dropdown-item :disabled="!chat.deletable" @click="deleteChat(chat)">{{ $t('삭제') }}</b-dropdown-item>
                    </b-dropdown>
                  </span>
                </div>
                <div style="white-space: pre-line;" v-html="chat.message"></div>
                <div v-if="chat.chatFileList.length > 0" class="mt-1">
                  <span v-for="(chatFile, index2) in chat.chatFileList" :key="index2" class="badge badge-sm badge-secondary me-1">
                    <a style="color:#009ef7 !important;" :href="$url(chatFile.url, true)" >{{ chatFile.filename }}</a>
                  </span>
                </div>
                <div v-if="!chat.confirm" class="d-flex flex-end">
                  <a href="#" class="link" @click="confirmChat(chat)">{{ $t('확인') }}</a>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <div class="wrap_pagination w-100 d-flex justify-content-between align-items-center px-3">
      <a v-if="writable" href="#" id="chatForm" class="btn btn-icon btn-sm btn-circle btn-light-primary" 
        :class="{'invisible': recipientList.length == 0}"
        style="box-shadow: 0px 0px 16px 0px rgba(76, 87, 125, 0.5) !important;" @click="showChatForm()">
        <i class="bi bi-chat-text-fill fs-4"></i>
      </a>
    </div>

    <b-popover ref="chatForm" :target="this.targetId" triggers="click" placement="lefttop" custom-class="chat_form exclude_close_overlays" delay="0">
      <div class="d-flex flex-end">
        <i class="bi bi-x fs-2 link ms-2 fw-bolder" :title="$t('닫기')" @click="closeChatForm"></i>
      </div>
      <div>
        <div v-if="recipientList.length > 1" class="form-check form-check-sm form-check-custom form-check-solid mb-3">
          <input type="checkbox" class="form-check-input" id="recipient_all" value="all" />
          <label for="recipient_all" class="ps-3">{{ $t('전체선택') }}</label>
        </div>
        <div v-for="(recp, index) in recipientList" :key="index" class="form-check form-check-sm form-check-custom form-check-solid mb-3">
          <input type="checkbox" class="form-check-input" name="recipient" :id="`recipient_${recp.key}`" 
            v-model="chatData.recipients[index]" :true-value="recp.key" />
          <label :for="`recipient_${recp.key}`" class="ps-3">{{recp.text}}</label>
        </div>
      </div>
      <div class="mt-4">
        <textarea name="message" v-model="chatData.message" style="width:100%; height: 72px;" :placeholder="$t('메시지')"></textarea>
      </div>
      <div class="mt-2">
        <FileUploadView :files="this.chatData.files" :deleteFileIds="this.chatData.deleteFileIds"></FileUploadView>
      </div>
      <div class="d-flex flex-end mt-4 mb-2">
        <a class="btn btn-sm btn-secondary" v-text="$t('닫기')" @click="closeChatForm" />
        <a class="btn btn-sm btn-primary ms-2" v-text="actionText" @click="insertChat" />
      </div>
    </b-popover>
  </div>
</template>
  
<script>
import FileUploadView from "@/components/cmm/FileUploadView.vue";

export default {
  components: { FileUploadView },
  props: {
    recipientList: [],
    chatList: [],
    writable: { default: () => true },
  },
  data: () => ({
    chatData: { messageId: '', recipients: [], message: '', files: [], deleteFileIds: [] },
    targetId: '',
    autoScroll: true,
    actionText: '',
  }),
  mounted() {
    this.scrollBottom(true);

    this.$root.$on('bv::popover::shown', () => {
      const recipientAllEl = document.getElementById('recipient_all');
      const recipientEls = document.getElementsByName('recipient');
      this.$setCheckEvent(recipientAllEl, recipientEls);
    });

    this.$root.$on('bv::popover::hidden', () => {
    });
  },
  watch: {
    chatList: {
      deep: true, 
      handler() { 
        this.closeChatForm();
        if(this.autoScroll) this.scrollBottom(false);
        this.autoScroll = true;
      } 
    },
  },
  methods: {
    async closeChatForm() {
      this.$refs.chatForm.$emit('close');
    },
    async showChatForm(chat) {
      await this.closeChatForm();

      this.chatData.messageId = '';
      this.chatData.recipients = [];
      this.chatData.message = '';
      this.chatData.files = [];
      this.chatData.deleteFileIds = [];
      if(chat) {
        this.actionText = this.$t('수정');
        this.$set(this.chatData, 'messageId', chat.messageId);
        if(chat.partiNos) this.$set(this.chatData, 'recipients', [...chat.partiNos]);
        this.$set(this.chatData, 'message', chat.message);
        if(chat.chatFileList) this.$set(this.chatData, 'files', [...chat.chatFileList]);
      } else {
        this.actionText = this.$t('작성');
      }

      this.targetId = chat ? `chatForm_${chat.messageId}` : 'chatForm';
      setTimeout(() => { this.$refs.chatForm.$emit('open'); }, 200);
    },
    async scrollBottom(auto) {
      this.closeChatForm();
      this.$nextTick(() => {
        const wrapChatEl = document.querySelector('.wrap_chat');
        wrapChatEl.scrollTo({ top: wrapChatEl.scrollHeight, behavior: auto === true ? 'auto' : 'smooth' });
      });
    },
    async insertChat() {
      const recipients = this.chatData.recipients.filter(item => item !== false);
      const files = this.chatData.files.filter(item => item instanceof File);
      const chatData = {
        messageId: this.chatData.messageId,
        recipients: recipients || [],
        message: this.chatData.message,
        files: files || [],
        deleteFileIds: this.chatData.deleteFileIds || []
      }

      if(this.chatData.messageId) { // 수정일 경우
        this.autoScroll = false;
      }

      await this.$emit('insertChat', chatData);
    },
    async confirmChat(chat) {
      this.autoScroll = false;
      await this.$emit('confirmChat', chat);
    },
    async deleteChat(chat) {
      this.autoScroll = false;
      await this.$emit('deleteChat', chat);
    },
  },
};
</script>

<style scoped>
.chat_form {
  min-width: 400px !important;
  font-size: 13px;
  z-index: 103;
  height: auto;
}

.wrap_pagination {
  flex-grow: 1;
  position: absolute;
  left: 2px;
  bottom: 10px;
}

.wrap_chat {
  padding-bottom: 40px !important;
}
</style>